import Vue from 'vue';
import Vuex from 'vuex';
import $axios from './api.js';
import $apiRegion from './api-region.js';

import auth from './store/auth.js';
import sender from './store/sender.js';
import transactionPrabayar from './store/transaction/prabayar.js';
import transactionPascabayar from './store/transaction/pascabayar.js';
import accountBusiness from './store/account/business.js';
import orderPastiCuan from './store/order/pasti-cuan.js';
import qrisMerchant from './store/qris-merchant.js';
import tos from './store/tos.js';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        token: localStorage.getItem('token'),
        customer: {
            account_verified: null,
            account_verified_status: false,
            account_detail: null,
            affiliate_id: '',
            balance: 0,
            email: null,
            email_verified: null,
            komisi: 0,
            poin: 0,
            name: '',
            phone: '',
            pin: true,
            pin_trx: '',
            referred_by: null,
            role: '',
            status: '',
            last_login: '',
            created_at: '',
            updated_at: '',
        },
        setting: {},
        groupProductSpecial: [],
        categoryPrabayar: [
            {
                icon: '',
                id: 1,
                index: 1,
                product_name: 'Loading...',
                withPrefix: 1,
            },
            {
                icon: '',
                id: 2,
                index: 2,
                product_name: 'Loading...',
                withPrefix: 1,
            },
            {
                icon: '',
                id: 3,
                index: 3,
                product_name: 'Loading...',
                withPrefix: 1,
            },
            {
                icon: '',
                id: 4,
                index: 4,
                product_name: 'Loading...',
                withPrefix: 1,
            },
            {
                icon: '',
                id: 5,
                index: 5,
                product_name: 'Loading...',
                withPrefix: 1,
            },
            {
                icon: '',
                id: 6,
                index: 6,
                product_name: 'Loading...',
                withPrefix: 1,
            },
            {
                icon: '',
                id: 7,
                index: 7,
                product_name: 'Loading...',
                withPrefix: 1,
            },
            {
                icon: '',
                id: 8,
                index: 8,
                product_name: 'Loading...',
                withPrefix: 1,
            },
            {
                icon: '',
                id: 9,
                index: 9,
                product_name: 'Loading...',
                withPrefix: 1,
            },
            {
                icon: '',
                id: 10,
                index: 10,
                product_name: 'Loading...',
                withPrefix: 1,
            },
            {
                icon: '',
                id: 11,
                index: 11,
                product_name: 'Loading...',
                withPrefix: 1,
            },
        ],
        categoryPascabayar: [],
        banner: [],
        errors: [],
        VUE_ENV: {
            VUE_APP_NAME: process.env.VUE_APP_NAME,
            VUE_APP_COMPANY_NAME: process.env.VUE_APP_COMPANY_NAME,
            VUE_APP_BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
            VUE_APP_ASSET_URL: process.env.VUE_APP_ASSET_URL,
            VUE_APP_PACKAGENAME_APK: process.env.VUE_APP_PACKAGENAME_APK,
            VUE_APP_LIMIT_SALDO: process.env.VUE_APP_LIMIT_SALDO,
            VUE_APP_MAX_TOPUP: process.env.VUE_APP_MAX_TOPUP,
            VUE_APP_MAX_TRX: process.env.VUE_APP_MAX_TRX,
            VUE_APP_LIMIT_TRX: process.env.VUE_APP_LIMIT_TRX,
            VUE_APP_GMAPS_APIKEY: process.env.VUE_APP_GMAPS_APIKEY,
        },
        loading: {
            button: false,
            app: true,
        },
        toast: {
            show: false,
            message: '',
            tipe: 'default',
            styled: 'top:0px;',
            position: 'top',
            icon: '',
        },
        device: '',
        provinces: [],
        regencies: [],
        districts: [],
        villages: [],
        districtsAll: [],
        version: {
            webapp: process.env.VUE_APP_VERSION,
        },
    },
    mutations: {
        SET_TOKEN(state, payload) {
            state.token = payload;
        },
        SET_CUSTOMER(state, payload) {
            state.customer = payload;
        },
        SET_SETTING(state, payload) {
            state.setting = payload;
        },
        SET_GROUP_PRODUCT_SPECIAL(state, payload) {
            state.groupProductSpecial = payload;
        },
        SET_CATEGORY_PRABAYAR(state, payload) {
            state.categoryPrabayar = payload;
        },
        SET_CATEGORY_PASCABAYAR(state, payload) {
            state.categoryPascabayar = payload;
        },
        SET_BANNER(state, payload) {
            state.banner = payload;
        },
        SET_ERRORS(state, payload) {
            state.errors = payload;
        },
        CLEAR_ERRORS(state) {
            state.errors = [];
        },
        SET_LOADING(state, payload) {
            if (payload.app == undefined) {
                state.loading = {
                    button: payload.button,
                    app: false,
                };
            }
            if (payload.button == undefined) {
                state.loading = {
                    button: false,
                    app: payload.app,
                };
            }
            // state.loading = payload
        },
        SET_TOAST(state, payload) {
            state.toast = payload;
        },
        RESET_LOADING(state) {
            state.loading = {
                button: false,
                app: true,
            };
        },
        RESET_TOAST(state) {
            state.toast = {
                show: false,
                message: '',
                tipe: 'default',
                styled: 'top:0px;',
                position: 'top',
                icon: '',
            };
        },
        SET_DEVICE(state, payload) {
            state.device = payload;
        },
        SET_PROVINCES(state, payload) {
            state.provinces = payload;
        },
        SET_REGENCIES(state, payload) {
            state.regencies = payload;
        },
        SET_DISTRICTS(state, payload) {
            state.districts = payload;
        },
        SET_VILLAGES(state, payload) {
            state.villages = payload;
        },
        SET_DISTRICTS_ALL(state, payload) {
            state.districtsAll = payload;
        },
        RESET_PROVINCES(state, payload) {
            state.provinces = payload;
        },
        RESET_REGENCIES(state, payload) {
            state.regencies = payload;
        },
        RESET_DISTRICTS(state, payload) {
            state.districts = payload;
        },
        RESET_VILLAGES(state, payload) {
            state.villages = payload;
        },
    },
    actions: {
        getCustomer({ state, commit }) {
            return new Promise((resolve, reject) => {
                $axios
                    .get('/customer')
                    .then(response => {
                        commit('SET_CUSTOMER', response.data.data);
                        state.loading.app = false;
                        resolve(response.data);
                    })
                    .catch(error => {
                        state.loading.app = false;
                        reject(error.response);
                    });
            });
        },
        getSetting({ state, commit }) {
            return new Promise((resolve, reject) => {
                $axios
                    .get('/setting')
                    .then(response => {
                        commit('SET_SETTING', response.data.data);
                        state.loading.app = false;
                        resolve(response.data);
                    })
                    .catch(error => {
                        state.loading.app = false;
                        reject(error.response);
                    });
            });
        },
        getGroupProductSpecial({ state, commit }) {
            return new Promise((resolve, reject) => {
                $axios
                    .get('/prabayar/product-special/group')
                    .then(response => {
                        commit('SET_GROUP_PRODUCT_SPECIAL', response.data.data);
                        state.loading.app = false;
                        resolve(response.data);
                    })
                    .catch(error => {
                        state.loading.app = false;
                        reject(error.response);
                    });
            });
        },
        getCategoryPrabayar({ state, commit }) {
            return new Promise((resolve, reject) => {
                $axios
                    .post('/prabayar/category')
                    .then(response => {
                        commit('SET_CATEGORY_PRABAYAR', response.data.data);
                        state.loading.app = false;
                        resolve(response.data);
                    })
                    .catch(error => {
                        state.loading.app = false;
                        reject(error.response);
                    });
            });
        },
        getCategoryPascabayar({ state, commit }) {
            return new Promise((resolve, reject) => {
                $axios
                    .post('/pascabayar/category')
                    .then(response => {
                        commit('SET_CATEGORY_PASCABAYAR', response.data.data);
                        state.loading.app = false;
                        resolve(response.data);
                    })
                    .catch(error => {
                        state.loading.app = false;
                        reject(error.response);
                    });
            });
        },
        getBanner({ state, commit }) {
            return new Promise((resolve, reject) => {
                $axios
                    .get('/banner')
                    .then(response => {
                        commit('SET_BANNER', response.data.data);
                        state.loading.app = false;
                        resolve(response.data);
                    })
                    .catch(error => {
                        state.loading.app = false;
                        reject(error.response);
                    });
            });
        },
        coming({ commit }) {
            commit('RESET_TOAST');
            commit('SET_TOAST', {
                show: true,
                message: 'Sabar yah.. Fitur ini masih dalam pengembangan',
                tipe: 'default',
                icon: 'warning',
            });
        },
        getProvinces({ commit }) {
            return new Promise((resolve, reject) => {
                $apiRegion
                    .get(`/provinces`)
                    .then(response => {
                        commit('SET_PROVINCES', response.data.responseData);
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        getRegencies({ commit }, payload) {
            return new Promise((resolve, reject) => {
                $apiRegion
                    .get(`/regencies/${payload}`)
                    .then(response => {
                        commit('SET_REGENCIES', response.data.responseData);
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        getDistricts({ commit }, payload) {
            return new Promise((resolve, reject) => {
                $apiRegion
                    .get(`/districts/${payload}`)
                    .then(response => {
                        commit('SET_DISTRICTS', response.data.responseData);
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        getDistrictsAll({ commit, state }) {
            return new Promise((resolve, reject) => {
                $apiRegion
                    .get(`/districts`)
                    .then(response => {
                        commit('SET_DISTRICTS_ALL', response.data.responseData);
                        localStorage.setItem(
                            'districtsData',
                            JSON.stringify(state.districtsAll)
                        );
                        resolve(response.data);
                    })
                    .catch(error => {
                        commit('SET_TOAST', {
                            show: true,
                            message:
                                'Gagal memuat beberapa data, tutup dan buka ulang aplikasi',
                            tipe: 'default',
                            icon: 'warning',
                        });
                        reject(error.response);
                    });
            });
        },
        getVillages({ commit }, payload) {
            return new Promise((resolve, reject) => {
                $apiRegion
                    .get(`/villages/${payload}`)
                    .then(response => {
                        commit('SET_VILLAGES', response.data.responseData);
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        updateApk() {
            window.open(
                'https://play.google.com/store/apps/details?id=com.digifazz.app',
                '_blank'
            );
        },
        checkVersion() {
            return new Promise((resolve, reject) => {
                $axios
                    .get('/check/version')
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
    },
    getters: {
        isAuth: state => {
            return state.token != 'null' && state.token != null;
        },
        isMaxTopup: state => value => {
            if (state.customer.role != 'H2H') {
                if (state.customer.account_verified == null) {
                    if (value <= state.VUE_ENV.VUE_APP_MAX_TOPUP) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            } else {
                return true;
            }
        },
        setPin: state => {
            return (
                state.customer.pin != undefined && state.customer.pin != null
            );
        },
    },
    modules: {
        auth,
        sender,
        transactionPrabayar,
        transactionPascabayar,
        accountBusiness,
        orderPastiCuan,
        qrisMerchant,
        tos,
    },
});
